import * as React from 'react';

import { Box, Card, CardContent, CardHeader, Typography } from '@mui/material';
import {
  DateField,
  EditButton,
  RecordContextProvider,
  TextField,
  useListContext,
  useTranslate,
} from 'react-admin';

import { IUser } from '../../types';

const MobileGrid = () => {
  const translate = useTranslate();
  const { data, isLoading } = useListContext<IUser>();

  if (isLoading || data.length === 0) {
    return null;
  }

  return (
    <Box margin="0.5em">
      {data.map((record) => (
        <RecordContextProvider key={record.id} value={record}>
          <Card sx={{ margin: '0.5rem 0' }}>
            <CardHeader title={`${record.code}`} action={<EditButton />} />
            <CardContent sx={{ pt: 0 }}>
              {/* <Typography variant="body2">
                {translate('resources.warranties.fields.code')}
                :&nbsp;
                <TextField source="code" />
              </Typography> */}
              <Typography variant="body2">
                {translate('resources.warranties.fields.date')}
                :&nbsp;
                <DateField source="date" />
              </Typography>
            </CardContent>
          </Card>
        </RecordContextProvider>
      ))}
    </Box>
  );
};

export default MobileGrid;
